import React from 'react';

export const ConfirmationContext = React.createContext({});
